import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import ParallaxBackground from '../ParallaxBackground'
import FloatingParticles from '../FloatingParticles'

export default function MainLayout() {
  return (
    <div className="min-h-screen">
      {/* Parallax Background with Mountains */}
      <ParallaxBackground />

      {/* Floating Particles */}
      <FloatingParticles count={25} />

      {/* Sidebar - glass effect */}
      <Sidebar />

      {/* Main content area */}
      <div className="ml-64 relative z-10">
        {/* Header - glass effect */}
        <Header />

        {/* Page content */}
        <main className="p-6 min-h-[calc(100vh-64px)]">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
